import { Component, EventEmitter, Input, NgModule, OnInit, Output } from '@angular/core';
import { AppBaseModule } from '../app-base.module';
import { SaraPlusFormModule } from '@sp-forms/saraplus-ngx-forms';
import { AppLayoutModule } from '../app-layout/app-layout.module';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-otp-verification-modal',
    templateUrl: './otp-verification-modal.component.html',
    styleUrl: './otp-verification-modal.component.scss',
    standalone: false
})
export class OtpVerificationModalComponent implements OnInit {

  @Input() heading = 'Please enter the six digit code sent to your email or phone';
  @Output() validate = new EventEmitter<string>();
  @Input() isVisible = false;
  @Output() isVisibleChange = new EventEmitter<boolean>();

  pinForm?: FormGroup;
  showErrorMessage = false;
  errorMessage?: string;
  ngOnInit(): void {
    this.pinForm = new FormGroup({
      pin: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{6,6}')]),
    })
  }

  onValidate() {
    if (this.pinForm?.valid) {
      this.validate.emit(this.pinForm.value?.pin);
    }
  }

  onPinValidated(isSuccess: boolean, message?: string) {
    if (isSuccess) {
      this.isVisible = false;
    } else {
      if (message) {
        this.showErrorMessage = true;
        this.errorMessage = message;
      }
    }
  }

  onModalHide() {
    this.isVisibleChange.emit(this.isVisible);
  }

  onModalShow(){
    this.pinForm?.reset();
  }
}


@NgModule({
  declarations: [
    OtpVerificationModalComponent
  ],
  imports: [
    AppBaseModule,
    SaraPlusFormModule,
    AppLayoutModule
  ],
  exports: [
    OtpVerificationModalComponent
  ]
})
export class OtpVerificationModalModule {

}